'use client';

import { useCallback, useSyncExternalStore } from 'react';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogIn } from 'lucide-react';
import { PrivyLoginButton } from '@/components/privy-login-button';
import {
  getLoginPromptModalSnapshot,
  hideLoginModal,
  LOGIN_PROMPT_MODAL_SSR_SNAPSHOT,
  subscribeLoginPromptModal,
} from '@/lib/login-prompt-modal-store';
import { Button } from '@/components/ui/button';

/**
 * 须挂在 Router 内（使用 useNavigate）。与 {@link showLoginModal} / {@link hideLoginModal} 配合使用。
 */
export function LoginPromptHost() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const snap = useSyncExternalStore(
    subscribeLoginPromptModal,
    getLoginPromptModalSnapshot,
    () => LOGIN_PROMPT_MODAL_SSR_SNAPSHOT
  );
  const goLogin = useCallback(() => {
    const redirect = snap.nextUrl?.trim() ||  window.location.href;
    hideLoginModal();
    // 如果地址相同，就不用处理了
    if (redirect === window.location.href) {
      return;
    }
    window.location.href = redirect;
    // window.location.href = redirect;
    // const qs = redirect ? `?redirect=${encodeURIComponent(redirect)}` : '';
    // navigate(`/login${qs}`);
  }, [navigate, snap.nextUrl]);

  return (
    <Modal
      open={snap.open}
      onCancel={() => hideLoginModal()}
      footer={null}
      closable={false}
      centered
      width={380}
      destroyOnHidden
      maskClosable
    >
      <div className="flex flex-col items-center text-center pt-4">
        <div className="mb-5 flex size-14 items-center justify-center rounded-2xl border border-primary-500 bg-primary-500/10 text-primary-500">
          <LogIn className="size-7" strokeWidth={2} />
        </div>
        <h2 className="text-lg font-semibold tracking-tight text-font-primary">{t('loginPrompt.title')}</h2>
        <p className="mt-2 text-sm text-font-gray">{t('loginPrompt.subtitle')}</p>
        <div className="mt-8 grid w-full grid-cols-2 gap-3">
          <PrivyLoginButton className='rounded-lg h-10' onLoginSuccess={goLogin} />
          <Button
            variant="secondary"
            onClick={() => hideLoginModal()}
            className='rounded-lg'
          >
            {t('loginPrompt.later')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { showLoginModal, hideLoginModal } from '@/lib/login-prompt-modal-store';
export type { LoginPromptModalOptions } from '@/lib/login-prompt-modal-store';
